import React from 'react';
import { Navigate } from 'react-router-dom';
import { useMarketplaceExperiment } from '../../contexts';

export const MARKETPLACE_SAFE_REDIRECT = '/';

const MarketplaceRouteGate = ({ children }) => {
    const { isResolved, marketplaceEnabled } = useMarketplaceExperiment();

    if (!isResolved) {
        return null;
    }

    if (!marketplaceEnabled) {
        return <Navigate replace to={MARKETPLACE_SAFE_REDIRECT} />;
    }

    return children;
};

export default MarketplaceRouteGate;
